import React, {Component} from 'react'
import classNames from 'classnames';
import {getBlockModelCalendarTypes, getBlockTitle, getPeriodNames} from '../../helpers/enrolment'

class Slider extends Component {
  constructor(props) {
    super(props)

    this.state = {
      currentSlide: 0,
      sliderPosition: 0,
      oldSliderPosition: 0,
      mouseX: null,
      titlePositionX: {},
    }
  }

  componentDidMount() {
    this.initialiseSlider(this.props)
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.selectedSlider !== this.props.selectedSlider ||
      prevProps.selectedSlide !== this.props.selectedSlide
    ) {
      this.initialiseSlider(this.props)
    }
  }

  initialiseSlider = props => {
    if (this.input && this.sliderInner && this.slider) {
      this.goToSelectedSlide(this.calculateSelectedSlide(props))
    }
  }

  goToPrevSlide = () => {
    if (this.canNavigateBackwards()) {
      const newWeekIndex = this.state.currentSlide - 1

      this.setState({
        currentSlide: newWeekIndex,
        sliderPosition: -this.getCorrectSliderPosition(newWeekIndex),
      })
    }
  }

  goToNextSlide = () => {
    if (this.canNavigateForwards()) {
      const newWeekIndex = this.state.currentSlide + 1

      this.setState({
        currentSlide: newWeekIndex,
        sliderPosition: -this.getCorrectSliderPosition(newWeekIndex),
      })
    }
  }

  goToSelectedSlide = currentWeek => {
    if (currentWeek && this.getUsableSlides().length > 0) {
      const currentWeekIndex = this.getCurrentWeekIndex(currentWeek)

      this.setState({
        currentSlide: currentWeekIndex > this.getMaxCurrentSlide() ? this.getMaxCurrentSlide() : currentWeekIndex,
        sliderPosition: -this.getCorrectSliderPosition(currentWeekIndex),
      })
    }
  }

  getMaxSliderPosition = () => {
    const sliderWidth = this.slider.offsetWidth
    const sliderInnerWidth = this.sliderInner.offsetWidth

    return sliderWidth - sliderInnerWidth
  }

  getMaxCurrentSlide = () => {
    const slides = this.getUsableSlides().filter((slide, index) => {
      return this.getSlideWidth(index) < Math.abs(this.getMaxSliderPosition())
    });

    return Math.max(0, slides.length - 1)
  }

  getCorrectSliderPosition = currentWeekIndex => {
    if (this.sliderInner.offsetWidth <= this.slider.offsetWidth) {
      return false
    }

    return Math.min(this.getSlideWidth(currentWeekIndex), Math.abs(this.getMaxSliderPosition()))
  }

  getCurrentWeekIndex = currentWeek => {
    return this.getInputSliderItems().findIndex(input => input === currentWeek)
  }

  getSlideWidth = slideItemIndex => {
    if (this.input) {
      return this.getInputSliderItems()
        .filter(sliderItemId => this.input.hasOwnProperty(sliderItemId))
        .filter((sliderItemId, index) => index < slideItemIndex)
        .reduce((accumulutar, currentValue) => {
          return accumulutar + this.input[currentValue].offsetWidth
        }, 0)
    }

    return this.getMinimumSlideWidth()
  }

  getInputSliderItems = () => Object.keys(this.input).filter(sliderItemId => {
    return this.props.weeks.some(sliderItem => sliderItem.id === sliderItemId)
  })

  getMinimumSlideWidth = () => 200

  calculateSelectedSlide = (props) => {
    return props.selectedSlide
  }

  canNavigate = () => this.canNavigateForwards() || this.canNavigateBackwards()

  canNavigateBackwards = () => {
    return this.input && Math.abs(this.state.sliderPosition) > 0
  }

  canNavigateForwards = () => {
    if (this.input) {
      if (this.sliderInner.offsetWidth < this.slider.offsetWidth) {
        return false
      }

      return Math.abs(this.state.sliderPosition) < Math.abs(this.getMaxSliderPosition())
    }
    return false
  }

  getSliderGroupTitle = title => {
    const blockModelCalTypes = getBlockModelCalendarTypes()

    if (blockModelCalTypes.findIndex(calType => calType === title) > -1) {
      return getBlockTitle(title)
    }

    return getPeriodNames(title)
  }

  getUsableSlides = () => {
    const slides = this.props.weeks

    if (this.props.enableGroups) {
      return this.props.weeks.filter(slide => this.props.groups.some(group => group === slide.group))
    }

    return slides
  }

  getSliderGroup = (sliderGroup, sliderItems = []) => {
    return (
      <section
        id={sliderGroup}
        key={sliderGroup}
        className="slider-group"
        ref={sliderGroupRef => {
          if (sliderGroupRef) {
            if (this.sliderGroups) {
              this.sliderGroups[sliderGroup] = sliderGroupRef
            } else {
              this.sliderGroups = {
                [sliderGroup]: sliderGroupRef
              }
            }
          }
        }}
      >
        {this.getSliderGroupHeader(sliderGroup)}
        <ul>
          {sliderItems.map(({id, url, title}) => (
            <li
              id={id}
              key={id}
              className={classNames(
                'slider-group__item',
                {'slider-group__item--active': id === this.calculateSelectedSlide(this.props)}
              )}
              ref={input => {
                if (!this.input) {
                  this.input = {}
                }

                if (input) {
                  this.input[id] = input
                } else {
                  delete this.input[id]
                }
              }}
            >
              <button
                className="slider-button"
                onClick={() => this.props.onSelectSlide(this.props.courseId, id)}
              >
                {title}
              </button>
            </li>
          ))}
          {sliderItems.length === 1 && <li className="slider-group__item"/>}
        </ul>
      </section>
    )
  }

  getSliderGroupHeader = sliderGroup => {
    if (!this.props.enableGroups || !(this.sliderGroups && this.sliderGroups[sliderGroup])) {
      return null
    }

    const sliderGroupKeys = Object.keys(this.sliderGroups)
    const sliderGroupIndex = sliderGroupKeys.findIndex(sliderGroupKey => sliderGroupKey === sliderGroup)
    if (sliderGroupIndex >= 0) {

      const calculateGroupTitlePositionX = sliderGroupTitle => {
        const sliderGroupOffset = sliderGroupKeys
          .filter((sliderGroupKey, index) => index < sliderGroupIndex)
          .filter(sliderGroupKey => this.sliderGroups[sliderGroupKey])
          .map(sliderGroupKey => this.sliderGroups[sliderGroupKey].offsetWidth)
          .reduce((accumulator, sliderGroupWidth) => {
            return accumulator + sliderGroupWidth
          }, 0)

        const sliderPosition = Math.abs(this.state.sliderPosition)
        if (sliderPosition > sliderGroupOffset) {
          const maxSliderGroupTranslate = this.sliderGroups[sliderGroup].offsetWidth - sliderGroupTitle.offsetWidth - 60

          if (sliderPosition - sliderGroupOffset > maxSliderGroupTranslate) {
            return maxSliderGroupTranslate
          } else {
            return sliderPosition - sliderGroupOffset
          }
        }

        return 0
      }

      const updateGroupTitlePositionX = sliderGroupTitleRef => {
        if (sliderGroupTitleRef) {
          const translateX = calculateGroupTitlePositionX(sliderGroupTitleRef)

          if (this.state.titlePositionX[sliderGroup] !== translateX) {

            this.setState({
              titlePositionX: {
                ...this.state.titlePositionX,
                [sliderGroup]: translateX
              },
            })
          }
        }
      }

      const translateX = this.state.titlePositionX.hasOwnProperty(sliderGroup) ? this.state.titlePositionX[sliderGroup] : 0

      return (
        <h2>
          <span
            id={sliderGroup + 'title'}
            key={sliderGroup + 'title'}
            style={{transform: `translateX(${translateX}px)`}}
            ref={updateGroupTitlePositionX}
          >
            {this.getSliderGroupTitle(sliderGroup)}
            </span>
        </h2>
      )
    }

    return null
  }

  startTouchDrag = event => {
    this.setState({
      oldSliderPosition: this.state.sliderPosition,
      mouseX: event.touches[0].clientX,
    })
  }

  moveTouchDrag = event => {
    this.applyDeltaToSliderPosition(event.changedTouches[0].clientX - this.state.mouseX)
  }

  applyDeltaToSliderPosition = delta => {
    const newSliderPosition = this.state.oldSliderPosition + delta

    this.setState({
      sliderPosition: newSliderPosition > 0 ? 0 : newSliderPosition < this.getMaxSliderPosition() ? this.getMaxSliderPosition() : newSliderPosition
    })
  }

  render() {
    if (this.getUsableSlides().length === 0) {
      return null
    }

    return (
      <div className={classNames(
        'slider-container-new',
        {'slider-container--not-grouped': !this.props.enableGroups}
      )}>
        {this.canNavigate() && (
          <button
            className={classNames(
              'slider-arrow',
              'slider-arrow--back',
              {'slider-arrow--disabled': !this.canNavigateBackwards()}
            )}
            disabled={!this.canNavigateBackwards()}
            onClick={() => this.goToPrevSlide()}
          >
            &nbsp;
          </button>
        )}
        {this.canNavigate() && (
          <button
            className={classNames(
              'slider-arrow',
              'slider-arrow--forward',
              {'slider-arrow--disabled': !this.canNavigateForwards()}
            )}
            disabled={!this.canNavigateForwards()}
            onClick={() => this.goToNextSlide()}
          >
            &nbsp;
          </button>
        )}

        <div className="slider-new" ref={slider => this.slider = slider}>

          <div
            onTouchStart={this.startTouchDrag}
            onTouchMove={this.moveTouchDrag}
            className="slider__inner"
            ref={sliderInner => this.sliderInner = sliderInner}
            style={{transform: `translateX(${this.state.sliderPosition}px)`}}
          >
            {!this.props.enableGroups && this.getSliderGroup(null, this.getUsableSlides())}

            {this.props.enableGroups && this.props.groups.map(sliderGroup => {
              const sliderItems = this.getUsableSlides()
                .filter(sliderItem => {
                  if (this.props.enableGroups) {
                    return sliderItem.group === sliderGroup
                  }
                  return true
                })

              if (sliderItems.length === 0) {
                return null
              }

              return this.getSliderGroup(sliderGroup, sliderItems)
            })}

          </div>

        </div>
      </div>
    )
  }
}

export default Slider
